import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomDataComponent } from './custom-data.component';
import {CardModule} from '../../resources/components/card/card.module';
import {RouterModule} from '@angular/router';
import {FormGroupContextModule} from '../../resources/modules/form-group-context/form-group-context.module';
import {FormGroupSimpleModule} from '../../resources/modules/form-group-context/form-group-simple/form-group-simple.module';
import {ValidateModule} from '../../resources/modules/validate/validate.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TableActionModule} from '../../resources/tables/table-action/table-action.module';
import {FormGroupSelectModule} from '../../resources/modules/form-group-context/form-group-select/form-group-select.module';
import {BtnDeleteModule} from '../../resources/components/btn-delete/btn-delete.module';
import { CustomDataFormComponent } from './custom-data-form/custom-data-form.component';
import { CustomDataCreateComponent } from './custom-data-create/custom-data-create.component';
import { CustomDataEditComponent } from './custom-data-edit/custom-data-edit.component';
import {MonacoEditorModule} from 'ngx-monaco-editor';
import { CustomDataRoutesModule } from './custom-data-routes/custom-data-routes.module';
import {LibraryListModule} from '../../resources/components/library-list/library-list.module';
import { PortalModule} from '@angular/cdk/portal';



@NgModule({
  declarations: [CustomDataComponent, CustomDataFormComponent, CustomDataCreateComponent, CustomDataEditComponent],
  imports: [
    CommonModule,
    CardModule,
    RouterModule,
    CustomDataRoutesModule,
    FormGroupContextModule,
    FormGroupSimpleModule,
    ValidateModule,
    FormsModule,
    ReactiveFormsModule,
    TableActionModule,
    FormGroupSelectModule,
    BtnDeleteModule,
    MonacoEditorModule,
    LibraryListModule,
    PortalModule
  ]
})
export class CustomDataModule { }
